/*
 * cv-pickup-store.js — "Ver dirección" de Recoger en tienda.
 *
 * shipping-quote.js pinta el botón [data-cv-pickup-store="gt|xela"] en cada
 * opción de recoger que trae el campo store del servicio de tarifas. Al tocarlo
 * se abre una ventana con la foto de la tienda, el mapa (Google Maps embebido,
 * sin clave), la dirección, el horario, los teléfonos y los botones Google
 * Maps, Waze y Compartir.
 *
 * Los datos salen de #cv-pickup-stores (snippets/cv-pickup-store.liquid). Con
 * latitud y longitud el mapa y los enlaces usan el pin; sin ellas, la dirección.
 * Una tienda sin pin ni dirección no tiene botón.
 *
 * La ventana va en <body> por encima del carrito lateral (z-index 9999) y
 * detiene sus clics y el Escape, para que no cierren el carrito ni el panel de
 * ubicación del header.
 *
 * API (window.CVPickupStore):
 *   has(code)          hay datos para mostrar esa tienda
 *   links(code)        { embed, google, waze } o null
 *   open(code, title)  abre la ventana
 *   close()
 */
(function() {
  'use strict';

  var cache = null;
  var modal = null;
  var lastFocus = null;
  var current = null;

  function read() {
    if (cache) return cache;
    cache = {};
    try {
      var node = document.getElementById('cv-pickup-stores');
      var parsed = node ? JSON.parse(node.textContent || '{}') : {};
      if (parsed && typeof parsed === 'object') cache = parsed;
    } catch (e) {}
    return cache;
  }

  function text(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function coordinate(value, limit) {
    var raw = text(String(value === undefined || value === null ? '' : value));
    if (!/^-?\d+(\.\d+)?$/.test(raw)) return null;
    var number = Number(raw);
    return Math.abs(number) <= limit ? number : null;
  }

  function point(data) {
    var lat = coordinate(data.lat, 90);
    var lng = coordinate(data.lng, 180);
    if (lat === null || lng === null || (lat === 0 && lng === 0)) return null;
    return { lat: lat, lng: lng };
  }

  function store(code) {
    var data = read()[String(code || '')];
    if (!data || typeof data !== 'object') return null;
    return text(data.address) || point(data) ? data : null;
  }

  function has(code) {
    return !!store(code);
  }

  function links(code) {
    var data = store(code);
    if (!data) return null;
    var pin = point(data);
    var place = encodeURIComponent(pin ? pin.lat + ',' + pin.lng : text(data.address));
    return {
      embed: 'https://maps.google.com/maps?q=' + place + '&z=16&output=embed',
      google: 'https://www.google.com/maps/dir/?api=1&destination=' + place,
      waze: 'https://waze.com/ul?' + (pin ? 'll=' : 'q=') + place + '&navigate=yes'
    };
  }

  function escapeHTML(value) {
    return String(value === undefined || value === null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Solo enlaces que arma el tema (tel:, https://wa.me/, mailto:).
  function safeUrl(value) {
    var url = text(value);
    return /^(tel:|mailto:|https:\/\/)/.test(url) ? url : '';
  }

  // Foto del CDN de Shopify (image_url da //dominio/cdn/...).
  function safeImage(value) {
    var url = text(value);
    return /^(https:)?\/\//.test(url) ? url : '';
  }

  var SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var ICONS = {
    pin: SVG + '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    clock: SVG + '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    phone: SVG + '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    chat: SVG + '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    google: SVG + '<polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
    waze: SVG + '<path d="M5 17a8 8 0 1 1 14.5-4.6c0 2.6-1.3 4.6-3.5 5.6"/><circle cx="8.5" cy="19" r="1.5"/><circle cx="15.5" cy="19" r="1.5"/><path d="M10 18h4"/><path d="M10 10h.01M14 10h.01"/><path d="M10 13.5a3 3 0 0 0 4 0"/></svg>',
    share: SVG + '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>',
    close: SVG + '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  };

  function build() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cv-ps';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="cv-ps__backdrop" data-cv-ps-close></div>' +
      '<div class="cv-ps__dialog" role="dialog" aria-modal="true" aria-labelledby="cv-ps-title">' +
        '<div class="cv-ps__photo" hidden></div>' +
        '<div class="cv-ps__head">' +
          '<h2 class="cv-ps__title" id="cv-ps-title"></h2>' +
          '<button type="button" class="cv-ps__close" data-cv-ps-close aria-label="Cerrar">' + ICONS.close + '</button>' +
        '</div>' +
        '<div class="cv-ps__map"></div>' +
        '<div class="cv-ps__body"></div>' +
      '</div>';
    // Clics y Escape se quedan aquí: el carrito y el panel del header no se cierran.
    modal.addEventListener('click', function(e) {
      e.stopPropagation();
      if (e.target.closest('[data-cv-ps-close]')) {
        e.preventDefault();
        close();
        return;
      }
      if (e.target.closest('[data-cv-ps-share]')) {
        e.preventDefault();
        share();
      }
    });
    document.body.appendChild(modal);
    return modal;
  }

  function row(icon, html) {
    return '<p class="cv-ps__row">' + ICONS[icon] + '<span>' + html + '</span></p>';
  }

  function fill(data, title) {
    var urls = links(current);
    var address = text(data.address);
    var hours = text(data.hours);
    var phoneUrl = safeUrl(data.phoneUrl);
    var whatsappUrl = safeUrl(data.whatsappUrl);
    var image = safeImage(data.image);
    var photo = modal.querySelector('.cv-ps__photo');
    modal.querySelector('.cv-ps__title').textContent = title;
    photo.innerHTML = image ? '<img src="' + escapeHTML(image) + '" alt="' + escapeHTML(title) + '" width="1000" height="400">' : '';
    photo.hidden = !image;
    // Con foto, la X flota sobre el banner.
    modal.querySelector('.cv-ps__dialog').classList.toggle('cv-ps__dialog--photo', !!image);
    modal.querySelector('.cv-ps__map').innerHTML =
      '<iframe src="' + escapeHTML(urls.embed) + '" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="Mapa: ' + escapeHTML(title) + '"></iframe>';
    var html = '';
    if (address) html += row('pin', escapeHTML(address));
    if (hours) html += row('clock', escapeHTML(hours).replace(/\n/g, '<br>'));
    var contact = [];
    if (phoneUrl && text(data.phone)) contact.push('<a href="' + escapeHTML(phoneUrl) + '">' + escapeHTML(text(data.phone)) + '</a>');
    if (whatsappUrl) contact.push('<a href="' + escapeHTML(whatsappUrl) + '" target="_blank" rel="noopener">WhatsApp</a>');
    if (contact.length) html += row(phoneUrl ? 'phone' : 'chat', contact.join(' · '));
    html += '<div class="cv-ps__actions">' +
      '<a class="cv-ps__btn" href="' + escapeHTML(urls.google) + '" target="_blank" rel="noopener">' + ICONS.google + 'Google Maps</a>' +
      '<a class="cv-ps__btn" href="' + escapeHTML(urls.waze) + '" target="_blank" rel="noopener">' + ICONS.waze + 'Waze</a>' +
      '<button type="button" class="cv-ps__btn" data-cv-ps-share>' + ICONS.share + 'Compartir</button>' +
      '</div>' +
      '<p class="cv-ps__status" role="status" aria-live="polite"></p>';
    modal.querySelector('.cv-ps__body').innerHTML = html;
  }

  function status(message) {
    var node = modal && modal.querySelector('.cv-ps__status');
    if (node) node.textContent = message;
  }

  // Comparte el nombre, la dirección y el enlace de Google Maps; sin Web Share, lo copia.
  function share() {
    var data = store(current);
    var urls = links(current);
    if (!data || !urls) return;
    var title = modal.querySelector('.cv-ps__title').textContent;
    var message = title + (text(data.address) ? '\n' + text(data.address) : '');
    if (navigator.share) {
      navigator.share({ title: title, text: message, url: urls.google }).catch(function() {});
      return;
    }
    var full = message + '\n' + urls.google;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(full).then(function() {
        status('Dirección copiada. Pégala donde quieras compartirla.');
      }, function() {
        window.open('https://wa.me/?text=' + encodeURIComponent(full), '_blank', 'noopener');
      });
      return;
    }
    window.open('https://wa.me/?text=' + encodeURIComponent(full), '_blank', 'noopener');
  }

  function focusables() {
    return Array.prototype.filter.call(
      modal.querySelectorAll('.cv-ps__dialog a[href], .cv-ps__dialog button, .cv-ps__dialog iframe'),
      function(node) { return !node.hidden; }
    );
  }

  function onKeydown(e) {
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.stopPropagation();
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'Tab') return;
    var nodes = focusables();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open(code, title) {
    var data = store(code);
    if (!data) return false;
    build();
    current = String(code);
    lastFocus = document.activeElement;
    fill(data, text(title) || 'Recoger en tienda');
    modal.hidden = false;
    document.documentElement.classList.add('cv-ps-locked');
    var button = modal.querySelector('.cv-ps__close');
    if (button) button.focus();
    return true;
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.querySelector('.cv-ps__map').innerHTML = '';
    modal.querySelector('.cv-ps__photo').innerHTML = '';
    document.documentElement.classList.remove('cv-ps-locked');
    current = null;
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (e) {}
    }
    lastFocus = null;
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest && e.target.closest('[data-cv-pickup-store]');
    if (!trigger) return;
    if (open(trigger.getAttribute('data-cv-pickup-store'), trigger.getAttribute('data-cv-pickup-name'))) e.preventDefault();
  });
  // En captura, antes que el Escape del carrito lateral.
  window.addEventListener('keydown', onKeydown, true);

  window.CVPickupStore = { has: has, links: links, open: open, close: close };
})();
